module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAG1BMVEXNKz/qKDnHJkEaIG2Nezb/1QAqrUQApVEApVG3fHnjAAAACXRSTlP//////////9TS8W7fAAAAMUlEQVR4Ae3TsQEAEAADQbBA9l/WDGm576/80TdTkzWQFwhy0hO/IIjFEMRiHxDELxdNJgEaz1a2DwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mu.png
// module id = Ee/E
// module chunks = 0